import * as Scrivito from "scrivito";

function ContentNavigationBlock({ page }) {
  return (
    <section className="py-5">
      <div className="container">
        <Scrivito.ContentTag
          tag="h1"
          className="h1 text-dark text-left"
          content={page}
          attribute="title"
        />
        <Scrivito.ChildListTag
          className="content-navigation-links"
          tag="ul"
          parent={page}
          renderChild={(child) => (
            <li>
              <Scrivito.LinkTag to={child}>
                {child.get("title")}
              </Scrivito.LinkTag>
            </li>
          )}
        />
      </div>
    </section>
  );
}

export default Scrivito.connect(ContentNavigationBlock);
